import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { StarFilled } from '@one-thd/sui-icons';
import {
  ExperienceContext,
  useConfigService,
} from '@thd-nucleus/experience-context';
import VirtualCheckoutID from '@thd-olt-component-react/virtual-checkout-id';
import { List } from '../../common/List/List';
import { getVerifiedBenefitsList } from '../../../constants/constants';
import { MaxDiscountMessage } from '../../common/MaxDiscountMessage/MaxDiscountMessage';
import { isB2BUser } from '../../../utils/utils';
import { track } from '../../../analytics/analytics';
import { VIRTUAL_ID_BTN } from '../../../constants/analytics';
import { getCheckoutAccessTypeLabel } from '../../../constants/general';

function VerifiedUser({ isMilitaryDiscountCapped }) {
  const { channel } = useContext(ExperienceContext);
  const [showQrCode, setShowQrCode] = useState(false);
  const isMobile = channel === 'mobile';
  const isTablet = channel === 'tablet';
  const showVerifyBtn = !isMilitaryDiscountCapped && (isMobile || isTablet);
  const isB2B = isB2BUser();
  const enableHdPass = !!useConfigService('ENABLE_HD_PASS_VERBIAGE');
  const checkoutAccessType = getCheckoutAccessTypeLabel(enableHdPass);

  return (
    <div className="sui-grid sui-gap-y-6 sui-mt-4 sui-w-full">
      {isMilitaryDiscountCapped && <MaxDiscountMessage />}
      <div>
        <div className="sui-flex sui-gap-x-2">
          <StarFilled color="brand" size="large" />
          <Typography variant="h2" color="brand">
            You&apos;re Enrolled!
          </Typography>
        </div>
        <Typography>Use your discount to shop online or in store.</Typography>
      </div>
      <List list={getVerifiedBenefitsList(checkoutAccessType)} />
      {showVerifyBtn && (
        <Button
          data-testid="showQRCodeBtn"
          onClick={() => {
            track(VIRTUAL_ID_BTN);
            setShowQrCode(true);
          }}
        >
          View {checkoutAccessType}
        </Button>
      )}

      {showQrCode && (
        <div data-testid="qrCode">
          <VirtualCheckoutID
            isB2B={isB2B}
            enableHdPass={enableHdPass}
            onClose={() => {
              setShowQrCode(false);
            }}
          />
        </div>
      )}
    </div>
  );
}

VerifiedUser.propTypes = {
  isMilitaryDiscountCapped: PropTypes.bool,
};
VerifiedUser.defaultProps = {
  isMilitaryDiscountCapped: false,
};

export default VerifiedUser;
